// Mock data for Meet Enterprise website

export const navigationLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Production", path: "/production" },
  {
    name: "Our Products",
    path: "/products",
    dropdown: [
      { name: "Acid Dyes", path: "/acid-dyes" },
      // { name: "Wool Dyes", path: "/wool-dyes" },
      { name: "Reactive Dyes", path: "/reactive-dyes" },
      { name: "Direct Dyes", path: "/direct-dyes" },
    ],
  },
  { name: "Blog", path: "/blog" },
  // { name: "Our Team", path: "/team" },
  { name: "Contact", path: "/contact" },
];

import img1Desktop from "./assets/updated_banner_1.png";
import img2Desktop from "./assets/updated_size_banner.png";
import img3Desktop from "./assets/banner_2.jpeg";
import img4Desktop from "./assets/banner_3.jpeg";
import img5Desktop from "./assets/updated_banner_2.png";
import img1Mobile from "./assets/banner_mobile_1.png";
import img2Mobile from "./assets/banner2_mobile.jpg";
import img3Mobile from "./assets/banner3_mobile.jpg";
import img4Mobile from "./assets/banner4_mobile.jpg";
import img5Mobile from "./assets/reactive_product_3.png";
import img1Tablet from "./assets/updated_banner_1.png";
import img5Tablet from "./assets/updated_banner_2.png";
import img2Tablet from "./assets/updated_size_banner.png";
import img3Tablet from "./assets/banner_2.jpeg";
import img4Tablet from "./assets/banner_3.jpeg";

export const banners = [
  { desktop: img5Desktop, mobile: img1Mobile, tablet: img1Tablet },
  // { desktop: img1Desktop, mobile: img1Mobile, tablet: img1Tablet },
  { desktop: img2Desktop, mobile: img2Mobile, tablet: img2Tablet },
  { desktop: img3Desktop, mobile: img3Mobile, tablet: img3Tablet },
  { desktop: img4Desktop, mobile: img4Mobile, tablet: img4Tablet },
];

export const heroFeatures = [
  {
    id: 1,
    title: "Quality dyes for vibrant textile applications.",
    image:
      "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=400,h=224,fit=crop/mk3qP2vBBMFD5b3a/whatsapp-image-2025-03-04-at-13.58.25_11d3f1a9-YrDq7Kb8REIEQoPO.jpg",
  },
  {
    id: 2,
    title: "Reliable chemicals for durable leather finishes.",
    image:
      "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=400,h=224,fit=crop/mk3qP2vBBMFD5b3a/whatsapp-image-2025-03-04-at-13.58.25_bdc4ba36-YleqOwlXpytbOV6r.jpg",
  },
  {
    id: 3,
    title: "Performance paints for stunning visual effects.",
    image:
      "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=400,h=224,fit=crop/mk3qP2vBBMFD5b3a/whatsapp-image-2025-03-04-at-13.58.25_eb2e1e5e-mnlqLQ8zEKT700xW.jpg",
  },
];
import acidImage1 from "./assets/acid_product_1.png";
import acidImage2 from "./assets/acid_product_2.png";
import acidImage3 from "./assets/acid_product_3.png";
import directImage1 from "./assets/di_1.png";
import directImage2 from "./assets/di_2.png";
import directImage3 from "./assets/di_3.png";
import reactiveImage1 from "./assets/reactive_product_1.png";
import reactiveImage2 from "./assets/reactive_product_2.png";
import reactiveImage3 from "./assets/reactive_product_3.png";

export const products = [
  {
    id: 1,
    title: "Acid Dyes",
    subtitle: "Manufacturer & Exporter : Acid Dyes",
    image: [acidImage1, acidImage2, acidImage3],
    path: "/acid-dyes",
    description:
      "Our acid dyes are specially formulated to provide brilliant, long-lasting colors for various textile applications. These dyes ensure excellent color fastness and maintain the natural luster of fabrics.",
    features: [
      "Excellent color fastness",
      "Maintains fabric luster",
      "High Durability",
      "Easy application",
      "Eco-friendly formulation",
    ],
    technicalSpecifications: [
      { label: "Form", value: "Powder" },
      { label: "Ionic Nature", value: "Anionic" },
      { label: "Solubility", value: "Water Soluble" },
      { label: "pH Range", value: "4.0 - 6.0" },
      { label: "Application Temperature", value: "85 - 98 C" },
      { label: "Recommended Fibers", value: "Wool, Silk, Nylon" },
    ],
    colorPalette: [
      { color: "#02000a", name: "Black MSRL" },
      { color: "#000028", name: "Blue MTR" },
      { color: "#022b8c", name: "Blue FF" },
      { color: "#0153a6", name: "Patent Blue AS" },
      { color: "#007b73", name: "Green V" },
    ],
  },
  {
    id: 2,
    title: "Reactive Dyes",
    subtitle: "Manufacturer & Exporter : Reactive Dyes",
    path: "/reactive-dyes",
    image: [reactiveImage1, reactiveImage3, reactiveImage2],
    description:
      "High quality reactive dyes for cotton. Our reactive dyes provide excellent color fastness and are suitable for a wide range of textile applications.",
    features: [
      "Excellent color fastness",
      "Wide shade range",
      "Good exhaustion",
      "Easy application",
      "Eco-friendly formulation",
    ],
    technicalSpecifications: [
      { label: "Form", value: "Powder / Granules" },
      { label: "Ionic Nature", value: "Anionic" },
      { label: "Solubility", value: "Water Soluble" },
      { label: "pH Range", value: "10.5 - 11.5 (fixation stage)" },
      { label: "Application Temperature", value: "30 - 60 C" },
      { label: "Recommended Fibers", value: "Cotton, Viscose, Cellulosics" },
    ],
    colorPalette: [
      { color: "#b2033a", name: "Red HE3B" },
      { color: "#f05a06", name: "Orange ME2RL" },
      { color: "#001b5d", name: "Blue H5G" },
      { color: "#010306", name: "Green HE4BD" },
      { color: "#eef101", name: "Yellow HE6G" },
    ],
    subTypes: [
      {
        slug: "he",
        name: "HE Series",
        description: "High Exhaust reactive dyes.",
        features: ["Excellent exhaustion", "Bright shades"],
      },

      {
        slug: "me",
        name: "ME Series",
        description: "Medium energy reactive dyes.",
        features: ["Balanced fixation", "Good fastness"],
      },

      {
        slug: "cold",
        name: "Cold Brand",
        description: "Low temperature dyeing range.",
        features: ["Energy saving", "Low temp process"],
      },
    ],
  },
  {
    id: 3,
    title: "Direct Dyes",
    subtitle: "Manufacturer & Exporter : Direct Dyes",
    image: [directImage1, directImage3, directImage2],
    path: "/direct-dyes",
    description:
      "Direct dyes suitable for both cotton and paper applications. These versatile dyes offer good color strength and are easy to apply.",
    features: [
      "Versatile application",
      "Good color strength",
      "Easy to apply",
      "Cost-effective",
      "Wide shade range",
    ],
    technicalSpecifications: [
      { label: "Form", value: "Powder" },
      { label: "Ionic Nature", value: "Anionic" },
      { label: "Solubility", value: "Water Soluble" },
      { label: "pH Range", value: "6.5 - 8.0" },
      { label: "Application Temperature", value: "80 - 100 C" },
      { label: "Recommended Fibers", value: "Cotton, Paper, Viscose" },
    ],
    colorPalette: [
      { color: "#d39005", name: "Yellow 5GLL" },
      { color: "#270b0e", name: "Brown MR" },
      { color: "#00023c", name: "Sky Blue FF" },
      { color: "#00000c", name: "Green B" },
      { color: "#07002a", name: "Violet" },
    ],
  },
];
import kiranImg from "./assets/Kiran Shah.png";
import kavishaImg from "./assets/Kavisha Shah.png";
import parshwaImg from "./assets/Parshwa Patel.jpeg";
import kinjalImg from "./assets/Kinjal Bhavsar.jpeg";
import hetviImg from "./assets/Screenshot_8.png";

export const teamMembers = [
  {
    id: 1,
    name: "Mr. Kiran Shah",
    position: "Founder & CEO",
    image: kiranImg,
    // bio: 'With over 20 years of experience in the chemical industry, Rajesh leads our vision for innovation and excellence.',
    // expertise: ['Business Strategy', 'Industry Relations', 'Product Development']
  },
  {
    id: 2,
    name: "Mrs. Kavisha Shah",
    position: "Head of Business Development",
    image: kavishaImg,
    // bio: 'PhD in Chemical Engineering with expertise in dye formulation and color science.',
    // expertise: ['Dye Chemistry', 'Quality Control', 'R&D']
  },
  {
    id: 3,
    name: "Mr. Parshwa Patel",
    position: "Production Manager",
    image: parshwaImg,
    // bio: 'Ensures efficient manufacturing processes and maintains the highest quality standards.',
    // expertise: ['Manufacturing', 'Process Optimization', 'Quality Assurance']
  },
  {
    id: 4,
    name: "Mr. Kalash Desai",
    position: "Sales Manager",
    image: hetviImg,
    // bio: 'Drives our market expansion and builds lasting relationships with clients worldwide.',
    // expertise: ['B2B Sales', 'Marketing Strategy', 'Client Relations']
  },
  {
    id: 5,
    name: "Mrs. Kinjal Bhavsar",
    position: "Human Resources Manager",
    image: kinjalImg,
    // bio: 'Provides expert technical guidance and support to our valued customers.',
    // expertise: ['Technical Support', 'Application Guidance', 'Training']
  },
];

export const stats = [
  { value: "150+", label: "Trusted by Businesses" },
  { value: "15+", label: "Years of Experience" },
  { value: "500+", label: "Color Variants" },
  { value: "20+", label: "Countries Served" },
];

export const certifications = [
  { name: "ISO 9001:2015", description: "Quality Management" },
  { name: "ISO 14001:2015", description: "Environmental Management" },
  { name: "OEKO-TEX", description: "Textile Safety" },
  { name: "GOTS", description: "Organic Textile Standard" },
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Mehta",
    company: "Practical & Professional Tone",
    role: "Textile Manufacturer",
    location: "Surat, India",
    content:
      "Consistent dye quality with accurate shades every time. Reliable service and quick responses make them easy to work with",
    // rating: 5,
  },
  {
    id: 2,
    name: "Priya Shah",
    company: "Warm & Relationship-Focused",
    role: "Fabric Exporter",
    location: "Mumbai, India",
    content:
      "Smooth experience, timely dispatch, and stable dye quality. Feels like a true business partner.",
    // rating: 5,
  },
  {
    id: 3,
    name: "Arvind Patel",
    company: "Detail-Oriented & Technical",
    role: " Processing Unit Owner",
    location: "Tiruppur, India",
    content:
      "Excellent color fastness and uniformity. Strong technical support and reliable performance across fabrics.",
    // rating: 5,
  },
  {
    id: 4,
    name: "Shamsur Rahman",
    company: "Straightforward & Results-Driven",
    role: "Dyeing Contractor",
    location: "Dhaka, Bangladesh",
    content:
      "Good quality, fair pricing, and on-time delivery. No follow-ups needed — very dependable.",
    // rating: 5,
  },
  {
    id: 5,
    name: "Mai Nguyễn",
    company: "Export-Focused & Trust-Building",
    role: "Import Manager",
    location: "Hanoi, Vietnam",
    content:
      "Consistent performance and clear communication. Seamless handling of international orders.",
    // rating: 5,
  },
];

export const clients = [
  "Textile Industries",
  "Leather Manufacturers",
  "Paint Companies",
  "Cosmetics Brands",
  "Paper Mills",
  "Fashion Houses",
];

export const companyInfo = {
  name: "Meet Enterprise",
  tagline: "Leading Mfg. & Exporter in color dyes and chemicals",
  description:
    "At Meet Enterprise, we specialize in providing businesses with the high-performance colour dyes and chemicals they need to succeed. Whether you're creating textiles, leather, Paint or Cosmetics, our solutions are designed to meet the highest standards of quality, reliability, and performance.",
  address:
    "G16, Golden Triangle Complex, nr. Sardar Patel Stadium Road, Chaitanya Nagar, Navrangpura, Ahmedabad 380014",
  phone1: "+91-9879574702",
  phone2: "+91-8128574702",
  email: "sales@meet-enterprise.com",
  whatsapp1: "+91-8128574702",
  whatsapp2: "+91-9879574702",
};

export const whyChooseUs = [
  {
    title: "Premium Quality",
    description:
      "All our products undergo rigorous quality checks to ensure consistent excellence.",
    icon: "award",
  },
  // {
  //   title: "Global Standards",
  //   description:
  //     "ISO certified manufacturing with international quality benchmarks.",
  //   icon: "globe",
  // },
  {
    title: "Expert Support",
    description:
      "24/7 technical assistance from our team of experienced chemists.",
    icon: "users",
  },
  {
    title: "Custom Solutions",
    description: "Tailored formulations to meet your specific requirements.",
    icon: "settings",
  },
  {
    title: "Eco-Friendly",
    description:
      "Sustainable manufacturing processes with minimal environmental impact.",
    icon: "leaf",
  },
  {
    title: "Industry Experience",
    description: "15+ years of expertise in dyes and chemicals manufacturing.",
    icon: "award",
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "understanding-reactive-dyes-in-textile-industry",
    title: "Understanding Reactive Dyes in the Textile Industry",
    excerpt:
      "Reactive dyes are the most widely used dyes for coloring cellulosic fibers like cotton. Learn about their chemistry, applications, and advantages.",
    content: `Reactive dyes have revolutionized the textile industry by providing excellent color fastness and vibrant shades on cotton and other cellulosic fibers.

## What Are Reactive Dyes?

Reactive dyes are a class of highly colored organic substances that form a covalent bond with the fiber substrate. This chemical bond ensures that the dye becomes an integral part of the fiber, resulting in excellent wash fastness.

## Chemistry Behind Reactive Dyes

The reactive group in these dyes can react with hydroxyl groups present in cellulose fibers. The most common reactive groups include:
- Monochlorotriazine (MCT)
- Dichlorotriazine (DCT)
- Vinyl sulfone (VS)
- Bifunctional reactive groups

## Application Process

The dyeing process with reactive dyes involves three main stages:
1. **Exhaustion**: Dye molecules move from the dye bath to the fiber
2. **Fixation**: Chemical reaction between dye and fiber
3. **Washing-off**: Removal of unfixed dye

## Advantages

- Excellent color fastness properties
- Wide range of bright shades
- Good reproducibility
- Moderate cost
- Suitable for various dyeing methods

## Meet Enterprise Reactive Dyes

At Meet Enterprise, we offer a comprehensive range of reactive dyes including HE Series, ME Series, and Cold Brand dyes to meet diverse industrial requirements.`,
    author: "Kavisha Shah",
    role: "Head of Business Development",
    date: "2024-01-15",
    category: "Textile Dyes",
    image:
      "https://images.unsplash.com/photo-1558171813-4c088753af8f?auto=format&fit=crop&w=800&h=500",
    readTime: "5 min read",
    tags: ["Reactive Dyes", "Cotton", "Textile"],
  },
  {
    id: 2,
    slug: "acid-dyes-for-wool-and-silk",
    title: "Acid Dyes: Perfect for Wool and Silk Fabrics",
    excerpt:
      "Discover how acid dyes provide brilliant, long-lasting colors for protein fibers like wool and silk, and why they're essential in the textile industry.",
    content: `Acid dyes are specifically designed to color protein fibers such as wool, silk, and nylon. These dyes offer excellent color fastness and maintain the natural luster of delicate fabrics.

## Understanding Acid Dyes

Acid dyes are water-soluble anionic dyes that are applied to fibers from an acidic dye bath. The name comes from the acidic conditions required for the dyeing process.

## How Acid Dyes Work

The dyeing mechanism involves:
- Formation of ionic bonds between dye molecules and fiber
- pH control is crucial for optimal dye uptake
- Temperature control ensures even dyeing

## Types of Acid Dyes

1. **Leveling Acid Dyes**: Good migration properties, used for even dyeing
2. **Milling Acid Dyes**: Better wet fastness, suitable for wool
3. **Supermilling Acid Dyes**: Excellent fastness properties

## Applications

- Woolen garments
- Silk textiles
- Nylon fabrics
- Leather finishing
- Carpet industry

## Meet Enterprise Acid Dyes

Our acid dyes are formulated to provide:
- Excellent color fastness
- Wide color range
- Easy application
- Eco-friendly formulation
- Consistent batch-to-batch quality`,
    author: "Kiran Shah",
    role: "Founder & CEO",
    date: "2024-01-10",
    category: "Specialty Dyes",
    image:
      "https://images.unsplash.com/photo-1520006403909-838d6b2528b6?auto=format&fit=crop&w=800&h=500",
    readTime: "4 min read",
    tags: ["Acid Dyes", "Wool", "Silk"],
  },
  {
    id: 3,
    slug: "sustainable-dyeing-practices-2024",
    title: "Sustainable Dyeing Practices for a Greener Future",
    excerpt:
      "Explore eco-friendly dyeing methods and sustainable practices that are transforming the textile industry while reducing environmental impact.",
    content: `The textile industry is increasingly adopting sustainable practices to reduce its environmental footprint. Sustainable dyeing is at the forefront of this transformation.

## Environmental Challenges

Traditional dyeing processes contribute to:
- High water consumption
- Chemical pollution
- Energy usage
- Waste generation

## Sustainable Solutions

### 1. Natural Dyes
- Plant-based dyes
- Biodegradable
- Non-toxic
- Limited color range

### 2. Low-Impact Synthetic Dyes
- Reduced heavy metals
- Lower salt requirements
- Better fixation rates
- Less wastewater pollution

### 3. Waterless Dyeing Technologies
- Supercritical CO2 dyeing
- Digital printing
- Reduced water consumption by up to 95%

### 4. Recycling and Reuse
- Water recycling systems
- Salt recovery
- Heat recovery from dye baths

## Meet Enterprise's Commitment

At Meet Enterprise, we are committed to sustainability through:
- Eco-friendly dye formulations
- ISO 14001:2015 Environmental Management certification
- Continuous R&D for greener alternatives
- Support for sustainable textile production

## Future Trends

- Bio-based dyes
- Enzyme-assisted dyeing
- Closed-loop systems
- Smart dyeing technologies`,
    author: "Parshwa Patel",
    role: "Production Manager",
    date: "2024-01-05",
    category: "Sustainability",
    image:
      "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?auto=format&fit=crop&w=800&h=500",
    readTime: "6 min read",
    tags: ["Sustainability", "Eco-Friendly", "Green Textile"],
  },
  {
    id: 4,
    slug: "color-fastness-testing-methods",
    title: "Understanding Color Fastness Testing Methods",
    excerpt:
      "Learn about essential color fastness tests that ensure textile products maintain their color quality through washing, light exposure, and rubbing.",
    content: `Color fastness is a critical quality parameter in the textile industry. It determines how well a fabric retains its color under various conditions.

## What is Color Fastness?

Color fastness refers to the resistance of a material to change in its color characteristics or to transfer its colorants to adjacent materials.

## Key Types of Color Fastness Tests

### 1. Wash Fastness
- Evaluates color retention after washing
- ISO 105-C06 standard
- Rated on a scale of 1-5 (5 being best)
- Critical for garments and home textiles

### 2. Light Fastness
- Measures resistance to fading from light exposure
- Xenon arc testing
- ISO 105-B02 standard
- Important for outdoor applications

### 3. Rubbing Fastness (Crocking)
- Tests color transfer during rubbing
- Dry and wet rubbing tests
- ISO 105-X12 standard
- Essential for upholstery and garments

### 4. Perspiration Fastness
- Evaluates color stability under sweat conditions
- Acidic and alkaline perspiration tests
- ISO 105-E04 standard
- Important for sportswear

### 5. Water Fastness
- Tests color resistance to water
- Simple but important test
- ISO 105-E01 standard

## Testing Standards

- ISO (International Organization for Standardization)
- AATCC (American Association of Textile Chemists and Colorists)
- ASTM (American Society for Testing and Materials)

## Importance in Quality Control

- Ensures customer satisfaction
- Meets regulatory requirements
- Reduces returns and complaints
- Maintains brand reputation

## Meet Enterprise Quality Assurance

All our dyes undergo rigorous testing to ensure:
- Consistent color fastness properties
- Compliance with international standards
- Reliable performance across applications`,
    author: "Kavisha Shah",
    role: "Head of Business Development",
    date: "2023-12-28",
    category: "Quality Control",
    image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&h=500",
    readTime: "7 min read",
    tags: ["Quality", "Testing", "Standards"],
  },
  {
    id: 5,
    slug: "direct-dyes-applications-advantages",
    title: "Direct Dyes: Applications and Advantages",
    excerpt:
      "Direct dyes offer versatile applications for cotton and paper. Learn about their unique properties and why they remain popular in various industries.",
    content: `Direct dyes are anionic dyes that can dye cellulosic fibers directly without the need for a mordant. They offer simplicity and cost-effectiveness in dyeing processes.

## What Makes Direct Dyes Unique?

Direct dyes are characterized by:
- Linear molecular structure
- Water solubility
- Ability to hydrogen bond with cellulose
- No chemical reaction required with fiber

## Applications

### Textile Industry
- Cotton fabrics
- Viscose rayon
- Paper textiles
- Linen materials

### Paper Industry
- Colored paper products
- Packaging materials
- Specialty papers
- Tissue papers

### Other Applications
- Leather finishing
- Ink manufacturing
- Colorants for cosmetics

## Advantages

1. **Cost-Effective**: Lower cost compared to reactive dyes
2. **Easy Application**: Simple dyeing process
3. **Wide Color Range**: Available in many shades
4. **Good Leveling**: Even dye distribution
5. **Versatile**: Suitable for multiple substrates

## Limitations

- Moderate wash fastness
- Requires after-treatment for improvement
- Limited light fastness in some cases

## After-Treatment Methods

- Cationic fixing agents
- Resin treatments
- Metal salt treatments

## Meet Enterprise Direct Dyes

Our direct dyes offer:
- Excellent color strength
- Easy application process
- Cost-effective solutions
- Wide shade range
- Consistent quality

## Future Developments

- Improved fastness properties
- Eco-friendly formulations
- Enhanced compatibility with other treatments`,
    author: "Kiran Shah",
    role: "Founder & CEO",
    date: "2023-12-20",
    category: "Textile Dyes",
    image:
      "https://images.unsplash.com/photo-1565514020176-8453f9a212d4?auto=format&fit=crop&w=800&h=500",
    readTime: "5 min read",
    tags: ["Direct Dyes", "Cotton", "Paper"],
  },
  {
    id: 6,
    slug: "global-textile-market-trends-2024",
    title: "Global Textile Market Trends and Outlook 2024",
    excerpt:
      "An analysis of current trends in the global textile industry, including emerging markets, technological advancements, and sustainability initiatives.",
    content: `The global textile industry is undergoing significant transformation driven by technological innovation, sustainability concerns, and changing consumer preferences.

## Market Overview

The global textile market continues to grow with:
- Market size exceeding $1 trillion
- Asia-Pacific leading production
- Growing demand for sustainable textiles
- Increasing focus on technical textiles

## Key Trends for 2024

### 1. Sustainability Focus
- Circular economy models
- Recycled materials
- Biodegradable textiles
- Water conservation technologies

### 2. Digital Transformation
- Industry 4.0 integration
- AI in textile manufacturing
- Digital printing adoption
- Smart textiles development

### 3. Supply Chain Resilience
- Nearshoring trends
- Diversified sourcing
- Blockchain for transparency
- Local manufacturing initiatives

### 4. Consumer Preferences
- Demand for organic and natural fibers
- Preference for sustainable brands
- Interest in custom products
- Ethical sourcing concerns

## Regional Insights

### Asia-Pacific
- Largest textile producer
- Growing domestic market
- Investment in technology
- Focus on sustainability

### Europe
- High-quality production
- Strong sustainability focus
- Innovation hub
- Premium market segment

### North America
- Technical textiles leadership
- Sustainable manufacturing
- Innovation in smart textiles
- Reshoring initiatives

## Technology Trends

- Automated manufacturing
- IoT integration
- 3D knitting technologies
- Nanotechnology applications

## Meet Enterprise Positioning

We are aligned with these trends through:
- Eco-friendly dye formulations
- Technical support for sustainable production
- Global supply chain capabilities
- Investment in R&D

## Future Outlook

The textile industry will continue to evolve with:
- Greater emphasis on sustainability
- Increased digital integration
- Focus on circular economy
- Growth in technical textiles`,
    author: "Kavisha Shah",
    role: "Head of Business Development",
    date: "2023-12-15",
    category: "Industry Insights",
    image:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=800&h=500",
    readTime: "8 min read",
    tags: ["Market Trends", "Industry", "Future"],
  },
];

import cert1 from "./assets/gst.png";
import cert2 from "./assets/govt.png";
import cert3 from "./assets/udhyam.png";
import cert4 from "./assets/Shop & Establishment.jpg";

export const certificateHome = [cert1, cert2, cert3, cert4];
